import { createAction, props } from '@ngrx/store';

export const REDIRECT_TO = createAction('[Core] Redirect To', props<{ path: string }>());
export const LOGOUT = createAction('[Core] Logout');
export const CHANGE_ACCOUNT = createAction('[Core] Change Account');
export const CHANGE_ACCOUNT_SUCCESS = createAction('[Core] Change Account Success');
export const CORE_CLEAR_STATE = createAction('[Core] Clear State');